import React from 'react';
// @ts-ignore
import styles from './index.m.less';

const noAuthImg = require('@/assets/images/no-auth.png'),

 NoAuth = () => {
    return (
        <div className={styles['no-auth']}>
            <img className={styles['img']} src={noAuthImg}/>
            <div className={styles['text']}>您没有该组织的访问权限，如有疑问 请联系管理员</div>
        </div>
    );
};

export default NoAuth;
